"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.identifyUser = identifyUser;
const utils_1 = require("@aws-amplify/core/internals/utils");
const pinpoint_1 = require("@aws-amplify/core/internals/providers/pinpoint");
const utils_2 = require("../../../utils");
const utils_3 = require("../utils");
async function identifyUser(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    const { userId, userProfile, options } = input;
    const { credentials, identityId } = await (0, utils_3.resolveCredentials)(ctx);
    const { appId, region } = (0, utils_3.resolveConfig)(ctx);
    const { userAttributes } = options ?? {};
    await (0, pinpoint_1.updateEndpoint)({
        appId,
        category: 'Analytics',
        credentials,
        identityId,
        region,
        userAttributes,
        userId,
        userProfile,
        userAgentValue: (0, utils_2.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.IdentifyUser),
    });
}
